module.exports = __webpack_public_path__ + "img/about-page-icon-casino.a09b1c91.svg";